import { ref } from 'vue';

import pendingLateDeductionService from '@/services/pendingLateDeductionService.js';

/**
 * Loads the pre-submit late notice for one activity. A failed request leaves `pending`
 * null: the notice is advice, and it must never block or break the submission screen.
 *
 * @returns {{ pending: import('vue').Ref<object|null>, loading: import('vue').Ref<boolean>, load: (activityId: number|string) => Promise<void> }}
 */
export function usePendingLateDeduction() {
    const pending = ref(null);
    const loading = ref(false);

    async function load(activityId) {
        if (!activityId) {
            pending.value = null;

            return;
        }

        loading.value = true;

        try {
            pending.value = await pendingLateDeductionService.getForActivity(activityId);
        } catch {
            pending.value = null;
        } finally {
            loading.value = false;
        }
    }

    return { pending, loading, load };
}
